<h2 mat-dialog-title>Add New User</h2>
<mat-dialog-content>
  <form (ngSubmit)="onSubmit()">
    <mat-form-field class="full-width" appearance="outline" color="accent">
      <mat-label>Email</mat-label>
      <input matInput [(ngModel)]="data.email" name="email" required>
    </mat-form-field>

    <mat-checkbox [(ngModel)]="data.isAdmin" name="isAdmin">Is Admin</mat-checkbox>

    <div mat-dialog-actions>
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-raised-button type="submit">Add User</button>
    </div>
  </form>
</mat-dialog-content>
